import { CopyQuoteFormModel, CopyQuotePayloadModel } from 'models/quote';

export function getPayload(formData: CopyQuoteFormModel): CopyQuotePayloadModel {
  const { client: newClient, ...rest } = formData;
  return { ...rest, client: newClient.value };
}
